export default "__VITE_ASSET__i3$1n46p__"